// Copyright (c) 2017 Comsearch, Inc., All rights reserved

export const INVALID_ANTENNA_MANUFACTURER = 'Invalid Antenna Manufacturer.'
